export default "__VITE_ASSET__KwOm3LcS__"